module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-right": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "¿Para qué sirve un presupuesto?",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("¿Para qué sirve un"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" presupuesto?")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only ",
    attrs: {
      "xs12": "",
      "sm2": "",
      "text-xs-right": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInRight",
    attrs: {
      "imaSize": 250,
      "imaSrc": "design/banco1-1-3-2",
      "imaAlt": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¿Para qué sirve un presupuesto?',
      "videoEmbed": "ADMINISTRACIONDINERO18ParaQueSirvePresupuesto(49).mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeIn dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 450,
      "imaSrc": "contenido/diapositiva_19",
      "imaAlt": "Ejemplo de presupuesto familiar"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "text-box adorn-right"
  }, [_vm._v("\n        Un presupuesto\n        "), _c('strong', [_vm._v("clarifica")]), _vm._v(" los\n        "), _c('strong', [_vm._v("ingresos")]), _vm._v(" recibidos y los\n        "), _c('strong', [_vm._v("gastos")]), _vm._v(" generados en un periodo de tiempo, además ayuda a alcanzar\n        "), _c('strong', [_vm._v("metas")]), _vm._v(" y a reconocer la\n        "), _c('strong', [_vm._v("realidad financiera")]), _vm._v(":\n        "), _c('br'), _c('br'), _vm._v(" "), _c('ui-list', {
    attrs: {
      "bullet": "bullet-dav",
      "lista": _vm.lista
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55d62d42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-18.vue
// module id = 988
// module chunks = 1